// extracted by mini-css-extract-plugin
export var adContainer = "index-module--adContainer--DpliK";
export var ad = "index-module--ad--rWEn3";
export var coverOver = "index-module--coverOver--NZNnD";